import { Flex } from '@raystack/apsara';

import GraphSection from '@src/components/Custom/ModelCommonComponents/CDCommonComponents/GraphSection';
import * as Skeleton from '@src/components/PixxelUIKit/Skeleton';
import { Show } from '@src/hoc';

type graph = {
  [key: string]: string | number;
};

interface DeltaGraphProps {
  isLoading: boolean;
  barGraphData: graph[];
  stackGraphData: graph[];
}

export const DeltaGraph = ({
  isLoading,
  barGraphData,
  stackGraphData
}: DeltaGraphProps) => {
  return (
    <Flex
      style={{ width: '100%' }}
      gap='medium'
      direction='column'
      align='start'
    >
      {isLoading ? (
        <Skeleton.TileList />
      ) : (
        <Show
          when={
            barGraphData &&
            stackGraphData &&
            barGraphData.length > 0 &&
            stackGraphData.length > 0
          }
        >
          <GraphSection
            activeGraph={barGraphData}
            stackGraph={stackGraphData}
          />
        </Show>
      )}
    </Flex>
  );
};
